import React, { useState } from 'react'
import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from '../../../../partials/Partials';

function CompletnessWidget() {
    const [missing_data, setMissingData] = useState({})
    const { completed } = missing_data || 0;
    const { section } = missing_data || '';
    const uncompleted_list = [];
    let message = '';

    useEffect(() => {
        fetch('/api/lawyer_profiles_extended/current/missing_data/').then(res => {
            if (res.ok) {
                res.json().then(data => {
                    setMissingData(data)
                })
            }
        })
    }, [])

    if (section) {
        section.forEach((item, index) => {
            const { name, url } = item || ''
            uncompleted_list.push(
                <li className="uncompleted-item" key={index}>
                    <FontAwesomeIcon icon={faSquare}/>
                    <a href={url}>{name}</a>
                </li>
            )
        })
    }

    if (completed)
        if (completed <= 45) {
            message = 'Twój profil nie wygląda jeszcze zbyt profesjonalnie dla potencjalnych klientów'
        } else if (completed > 45 && completed <= 75) {
            message = 'Twój profil nie wygląda jeszcze w pełni profesjonalnie dla potencjalnych klientów'
        } else {
            message = 'Twój profil wygląda już prawie w pełni profesjonalnie! Uzupełnij jeszcze brakujące elementy i zdobywaj więcej wyświetleń!'
    }


  return (
    <div id="completness-widget">
        {completed < 100 ? 
            <>
            <h4>{completed}% wypełnienia profilu</h4>
            <div className="completness-box">
                <div className="completness-progress-bar">
                    <div className="progress-bar" style={{width: `${completed}%`}}></div>
                </div>
                <ul id="uncompleted-list">
                    {uncompleted_list}
                </ul>
            </div>
            <Tooltip text1={message} id="edit-completness-tooltip"/>
            </> :
            completed === 100 ?
            <div className="alert alert-success">
                <h4 className="text-center">
                    <FontAwesomeIcon icon={faTrophy} className='fa-trophy'/>
                    Wypełniłeś 100% swojego profilu!
                </h4>
            </div>
            : null
        }
    </div>
  )
}

export default CompletnessWidget